import enums from "raft/internal/enums";

type GetFilterValuesProps = {
  search?: string;
};

export const getPrimaryEnergySourceFilterValues = (search?: GetFilterValuesProps) => enums.primaryEnergySource;
